export default __webpack_public_path__ + "static/question2-diagram-c3ee451dea8590081db12eb6f27a48ff.png";